import { RouteObject } from "react-router";
import { paths } from "../shared/configs/paths";
import { MainLayout } from "./_layouts/main-layout";
import { HomePage } from "./home";
import { ArticlesDetails } from "./article-details";
import { getSuperTokensRoutesForReactRouterDom } from "supertokens-auth-react/ui";
import { ThirdPartyPreBuiltUI } from "supertokens-auth-react/recipe/thirdparty/prebuiltui";
import "../shared/configs/supertoken";
import * as reactRouterDom from "react-router-dom";
import { SessionAuth } from "supertokens-auth-react/recipe/session";
import { profileLoader } from "./_loaders/profileLoader";
import { composeLoaders } from "./_loaders/compose-loaders";
import { checkSessionLoader } from "./_loaders/sessionLoader";
import { CampaignDetailsPage } from "./campaign-details";

const superTokensRoutes = getSuperTokensRoutesForReactRouterDom(
  reactRouterDom,
  [ThirdPartyPreBuiltUI]
);

export const ROUTES: RouteObject[] = [
  {
    path: paths.auth,
    children: superTokensRoutes.map((row) => row.props as RouteObject),
  },
  {
    path: paths.home,
    loader: composeLoaders(checkSessionLoader, profileLoader),
    element: (
      <SessionAuth requireAuth={true}>
        <MainLayout />
      </SessionAuth>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: paths.campaignDetails,
        element: <CampaignDetailsPage />,
      },
      {
        path: paths.articleDetails,
        element: <ArticlesDetails />,
      },
    ],
  },
];
